import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useMapbox } from '../../hooks/useMapbox';

interface MapBoxProps {
  location?: [number, number] | null;
  cooperativeGestures?: boolean;
  enableGeocoder?: boolean;
  onLocationChange?: (location: [number, number], address: string, postcode: string, what3_words: string) => void;
}

export const MapBox: React.FC<MapBoxProps> = ({
  location,
  cooperativeGestures,
  enableGeocoder,
  onLocationChange,
}) => {
  const { mapContainer, isLoading, error } = useMapbox({
    location,
    cooperativeGestures,
    enableGeocoder,
    onLocationChange,
  });

  if (error) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          bgcolor: 'background.default',
        }}
      >
        <Typography color="error" variant="h6" gutterBottom>
          Map Error
        </Typography>
        <Typography color="text.secondary" variant="body2">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 1000,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <div ref={mapContainer} style={{ height: '100%', width: '100%' }} />
    </Box>
  );
};
